// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos do Modal de Versões do Projeto - Compatível com Modal de Prévias */

.styles_containerTitle__hO2H6 {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.styles_title__9bgs0 {
  color: #18316e;
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.styles_containerVersao__U\\+0Mx {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_itemVersao__f7LTg {
  align-items: center;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.6rem;
}

.styles_containerBtn__rzGZ4 {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.styles_btnAnalisar__vIIdx {
  background: #18316e !important;
}

.styles_btnAnalisar__vIIdx:hover {
  background: #204091 !important;
}

.styles_btnFechar__0e-eo {
  border-color: #18316e !important;
  color: #18316e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Projeto/ModalVersoesProjeto/styles.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":["/* Estilos do Modal de Versões do Projeto - Compatível com Modal de Prévias */\n\n.containerTitle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.title {\n  color: #18316e;\n  font-size: 1.5rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.containerVersao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemVersao {\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.3rem 0.6rem;\n}\n\n.containerBtn {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n\n.btnAnalisar {\n  background: #18316e !important;\n}\n\n.btnAnalisar:hover {\n  background: #204091 !important;\n}\n\n.btnFechar {\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerTitle": `styles_containerTitle__hO2H6`,
	"title": `styles_title__9bgs0`,
	"containerVersao": `styles_containerVersao__U+0Mx`,
	"itemVersao": `styles_itemVersao__f7LTg`,
	"containerBtn": `styles_containerBtn__rzGZ4`,
	"btnAnalisar": `styles_btnAnalisar__vIIdx`,
	"btnFechar": `styles_btnFechar__0e-eo`
};
export default ___CSS_LOADER_EXPORT___;
